import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shipping-container" }
const _hoisted_2 = { class: "shipping-costs-preview" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "result"
}
const _hoisted_6 = { class: "cost" }
const _hoisted_7 = { class: "unit" }
const _hoisted_8 = {
  key: 1,
  class: "result"
}
const _hoisted_9 = ["href"]

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShippingCostsPreview',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

const shippingDestinations = ref<any[]>([]);
const shippingDestination = ref<string>(null);
const shippingCost = ref<any>(null);
const isActive = ref(false);

onBeforeMount(() => {
    getShippingDestinations();
});

async function getShippingDestinations() {
    let response = (await Axios.post(routes.Cart_GetShippingDestinations)).data;
    
    shippingDestinations.value = response;
}

async function getShippingCosts() {
    if (shippingDestination.value) {
        let response = await Axios.post(routes.Cart_GetShippingCostsByDestination, { shippingDestination: shippingDestination.value });

        shippingCost.value = response.data;

        GTagHelper.sendEvent("click", "delivery_option", shippingDestination.value);
    } else {
        shippingCost.value = null;
    }
}

function formatPrice(data: any) {
    return Number(data).toFixed(2).replace(".", ",");
}

function setExpanding() {
    isActive.value = !isActive.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["button", { active: isActive.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setExpanding()))
      }, [
        _createTextVNode(_toDisplayString(_unref(localizer).get("Cart.Common.CalculateShippingCosts")), 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "icon fastic-angle-right fl-r" }, null, -1))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["preview form", { hden: !isActive.value }])
      }, [
        _withDirectives(_createElementVNode("select", {
          class: "dropdown",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shippingDestination).value = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (getShippingCosts()))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "...", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shippingDestinations.value, (listValue, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: listValue.value,
              key: index
            }, _toDisplayString(listValue.title), 9, _hoisted_3))
          }), 128))
        ], 544), [
          [
            _vModelSelect,
            shippingDestination.value,
            void 0,
            { lazy: true }
          ]
        ]),
        (shippingCost.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!shippingCost.value.isExWorkOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(localizer).get("Cart.Common.ShippingCostsIntro")) + " ", 1),
                    _createElementVNode("span", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                      _createTextVNode(_toDisplayString(formatPrice(shippingCost.value.shippingCost)), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_unref(localizer).get("App.Common.ShippingExWork")) + " ", 1),
                    _createElementVNode("a", {
                      href: _unref(routes).Support_ShippingReturns + '#ExWorks',
                      class: "link"
                    }, _toDisplayString(_unref(localizer).get("App.Common.ShippingExWork_More")), 9, _hoisted_9)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})